// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const clayPit = defineModel({
  id: "clay-pit",
  batchId: "future",
  name: "Clay pit",
  tags: ["scenery","clay","pit","low-poly","age-of-mcp","future"],
  summary: "A dug pit of wet clay. Raw material for bricks, tiles, pottery and crucibles.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.52,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.48, 0.52, 0.12, 9), color: "#9a5538", position: [0, 0.06, 0] },
      { geometry: new THREE.CylinderGeometry(0.38, 0.42, 0.1, 9), color: "#a86343", position: [0.04, 0.15, -0.02] },
      { geometry: new THREE.CylinderGeometry(0.26, 0.3, 0.09, 8), color: "#9a5538", position: [0.06, 0.23, -0.04] },
      { geometry: new THREE.CylinderGeometry(0.15, 0.19, 0.08, 8), color: "#834631", position: [0.08, 0.3, -0.05] },
      { geometry: new THREE.CylinderGeometry(0.2, 0.16, 0.06, 8), color: "#834631", position: [-0.16, 0.07, 0.16] },
      { geometry: new THREE.CylinderGeometry(0.13, 0.13, 0.02, 10), color: "#2c2620", position: [-0.16, 0.105, 0.16] },
      { geometry: new THREE.IcosahedronGeometry(0.08, 0), color: "#a86343", position: [0.28, 0.15, 0.22], rotation: [0.2, 0.6, 0.1], scale: [1.1, 0.8, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.07, 0), color: "#9a5538", position: [-0.34, 0.13, -0.1], rotation: [0.3, 1.2, 0.2], scale: [1, 0.8, 1.1] },
      { geometry: new THREE.IcosahedronGeometry(0.06, 0), color: "#834631", position: [0.12, 0.13, 0.34], rotation: [0.2, 0.4, 0.3], scale: [1.1, 0.7, 1] },
      { geometry: new THREE.TetrahedronGeometry(0.06, 0), color: "#a86343", position: [-0.1, 0.06, 0.36], rotation: [0.5, 1.5, 0.3] },
      { geometry: new THREE.IcosahedronGeometry(0.05, 0), color: "#9a5538", position: [0.34, 0.05, -0.18], rotation: [0.3, 0.8, 0.2], scale: [1.1, 0.7, 1] },
    ],
  animations: [],
});
